<template>
<main class="contents_main">
  <div class="contents">
    <section id="guide" class="guide">
      <h2 class="guide_t guild">{{$t("GUIDE_PAGE_TITLE_1")}}</h2>
      <div class="row guild-row u-mb40">
        <p class="col-4"><a href="#t_link1">
          1. 利用登録から取引終了までの流れ
        </a></p>
        <p class="col-4"><a href="#t_link2">
          2. 支払い手順について
        </a></p>
        <p class="col-4"><a href="#t_link3">
          3. 移動先や移動日時について
        </a></p>
      </div>
      <h3 id="t_link1" class="u-mb30">
        1. 利用開始から取引終了までの流れ
      </h3>
      <ul class="u-mb30 txt-ind2 li-mb15">
        <!-- <li> -->
          <!-- <img src="@/assets/images/guide/" /> -->
        <!-- </li> -->
        <li>
          ※1 出品申込手続き後は、主催者の認める特別な理由がない限り、出品取消しができません。
        </li>
        <li>
          ※2 セリ上場後に未売却の馬の出品や、トレセンなどの施設に在厩中の出品、オークション期間終了後にレース出走予定のある特殊なケースの場所であれば同じと判断します。
        </li>
        <li>
          ※3 主催者が認める在厩場所については、お電話かメールでお気軽にお問い合わせください。
          【 TEL：077-516-4398／E-MAIL：auction@normandyoc.com 】
        </li>
        <li>
          ※4 出品者からリザーブ価格（希望最低売り渡し額）設定がある場合は、オークション開始から60分以内に主催者が1度だけ入札を行います。この場合、落札候補者欄には「THOROUGHBRED AUCTION」が表示されます。
        </li>
        <li>
          ※5 オークション取引は現金振込のみの取り扱いとなります。
        </li>
        <li>
          ※6 既定の手数料として販売申込手数料の22,000円～44,000円(税込)、売買手数料（出品馬が落札された場合のみ税込落札額の5%）を査収いたします。
        </li>
        <li>
          ※7 オークション終了後、翌々日から引取までの期間の在厩場所への預託料は落札者負担となります。
        </li>
      </ul>

      <h3 id="t_link2" class="u-mb30">
        2. 支払い手順について
      </h3>
      <ul class="u-mb30 txt-ind1">
        <li>
          ①落札しますと、下記のようなメールが届きます。
        </li>
        <li class="u-pt15">
          ※楽天会員にご登録いただいたメールアドレス宛に届きます。
        </li>
        <li>
          ※サラブレッドオークションに利用申請した際のメールアドレスとは異なりますので、ご注意ください。
        </li>
        <li class="u-ta-c u-pv20">
          <img src="@/assets/images/guide/img_mail_01.jpg" />
        </li>
        <li>
          ※オークション終了後、１時間経過してもメールが届かない場合は、サラブレッドオークション事務局までご連絡ください。
        </li>
        <li class="u-pt15">
          ②メール内の下記内容に間違いがないかを確認してください。<br />
          落札馬名<br />
          落札価格
          </li>
          <li class="u-pt15">
            ③間違いがなければ、指定日までに代金をお振込みください。<br />
            お振込先口座、振込み期日にご注意ください。
          </li>
          <li class="u-pt15">
            ※お振込先口座は、変わる場合がありますのでご注意ください。
          </li>
          <li>
            ※お支払いは現金振込みのみのお取り扱いとなります。
          </li>
          <li>
            ※指定された期日までにご入金の確認ができない場合、落札がキャンセルとなる場合がありますので、ご注意ください。
          </li>
      </ul>
      <h3 id="t_link3" class="u-mb30">
        3. 移動先や移動日時について
      </h3>
      <ul class="u-mb30 li-mb15">
        <li>
          お手数ですが、サラブレッドオークション事務局までお電話またはメールにてご連絡ください。
        </li>
        <li>
          ※落札場の馬運車による輸送移動（馬運車輸送）にかかる移動費は、移動先によって異なり、必要経費は落札者様のご負担となります。
        </li>
      </ul>

    </section>
  </div>
</main>
</template>

<script>
import Methods from '@/api/methods'
export default {
  data() {
    return {
      scripts        : [],
      samleFiles     : [],
      sampleFile1    : {},
      sampleFile2    : {},
      sampleFile3    : {},
      calendarImage  : {},
      auctionPcImage : {},
      auctionSpImage : {}
    }
  },
  mounted() {
    Methods.addExternalScripts(this.scripts)
  },
  methods : {
    padArray(array, length) {
      for (let i = 0;i < length;i++) {
        array.push({})
      }
      array.splice(length)
      return array
    }
  },
}
</script>
<style scoped>
  .contents_main .contents p {
    margin-bottom: initial !important;
  }
  .col-4 {
    padding-right: 15px !important;
    padding-left: 15px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>
<style scoped src="@/assets/css/contents03.css"></style>
